export default __webpack_public_path__ + "static/media/kitchenwares.9c004ae6.jpg";